import SectionCountries from '../../../../containers/LandingPage/SectionCountries';
import { withBaseComponent } from '../../hoc/withBaseComponent';

const StoryblokCountriesWomoPreset = () => {
  return <SectionCountries />;
};

export default withBaseComponent(StoryblokCountriesWomoPreset);
